import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LanguageContext";
import { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error("Password must be at least 6 characters.");
      return;
    }
    setLoading(true);
    try {
      await register(form);
      toast.success(t("register") + " ✓");
      navigate("/apply");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("register")}>
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div>
          <Label htmlFor="name">{t("full_name")}</Label>
          <Input id="name" required value={form.name} onChange={set("name")} data-testid="register-name-input" className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="email">{t("email")}</Label>
          <Input id="email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email-input" className="mt-1.5" />
        </div>
        <div>
          <Label htmlFor="phone">{t("phone")}</Label>
          <Input id="phone" type="tel" value={form.phone} onChange={set("phone")} data-testid="register-phone-input" className="mt-1.5" placeholder="+91…" />
        </div>
        <div>
          <Label htmlFor="password">{t("password")}</Label>
          <Input id="password" type="password" required value={form.password} onChange={set("password")} data-testid="register-password-input" className="mt-1.5" />
        </div>
        <Button type="submit" disabled={loading} className="w-full bg-[#8B1E2B] hover:bg-[#6f1622] text-white" data-testid="register-submit-button">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} {t("register")}
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-slate-600">
        {t("have_account")} <Link to="/login" className="text-[#8B1E2B] font-semibold hover:underline" data-testid="go-login">{t("login")}</Link>
      </p>
    </AuthShell>
  );
}
